import { render, staticRenderFns } from "./modulePreview.vue?vue&type=template&id=16316671&scoped=true"
import script from "./modulePreview.vue?vue&type=script&lang=js"
export * from "./modulePreview.vue?vue&type=script&lang=js"
import style0 from "./modulePreview.vue?vue&type=style&index=0&id=16316671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16316671",
  null
  
)

export default component.exports